import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Map from "../containers/Map";
import { Home } from "../containers/Home";
import { Camera } from "../containers/Camera";
import { SignTable } from "../containers/SignsTableView";
import { UpperToolbar } from "../components/UpperToolbar";
import { Loader } from "../components/Loader";
import { ChangeSign } from "../containers/ChangeSign";

interface Props {}

export const RouteResolver = (props: Props) => {
  return (
    <Router>
      <UpperToolbar />
      <Switch>
        <Route exact path="/ChangeSign/:id" component={ChangeSign} />
        <Route exact path="/Map" component={Map} />
        <Route exact path="/SignTable" component={SignTable} />
        <Route exact path="/Loader" component={Loader} />
        <Route exact path="/Camera" component={Camera} />
        <Route exact path="/" component={Camera} />
      </Switch>
    </Router>
  );
};
